import axios from 'axios';
import Auth from '../../auth/auth';

export const schemaMonitorActions = {
  LOAD_CONFIGS_REQUEST: 'SM_LOAD_CONFIGS_REQUEST',
  LOAD_CONFIGS_SUCCESS: 'SM_LOAD_CONFIGS_SUCCESS',
  LOAD_CONFIGS_FAILURE: 'SM_LOAD_CONFIGS_FAILURE',

  CREATE_CONFIG_REQUEST: 'SM_CREATE_CONFIG_REQUEST',
  CREATE_CONFIG_SUCCESS: 'SM_CREATE_CONFIG_SUCCESS',
  CREATE_CONFIG_FAILURE: 'SM_CREATE_CONFIG_FAILURE',

  UPDATE_CONFIG_REQUEST: 'SM_UPDATE_CONFIG_REQUEST',
  UPDATE_CONFIG_SUCCESS: 'SM_UPDATE_CONFIG_SUCCESS',
  UPDATE_CONFIG_FAILURE: 'SM_UPDATE_CONFIG_FAILURE',

  DELETE_CONFIG_REQUEST: 'SM_DELETE_CONFIG_REQUEST',
  DELETE_CONFIG_SUCCESS: 'SM_DELETE_CONFIG_SUCCESS',
  DELETE_CONFIG_FAILURE: 'SM_DELETE_CONFIG_FAILURE',

  DISABLE_CONFIG_REQUEST: 'SM_DISABLE_CONFIG_REQUEST',
  DISABLE_CONFIG_SUCCESS: 'SM_DISABLE_CONFIG_SUCCESS',
  DISABLE_CONFIG_FAILURE: 'SM_DISABLE_CONFIG_FAILURE',

  SOFT_DELETE_CONFIG_REQUEST: 'SM_SOFT_DELETE_CONFIG_REQUEST',
  SOFT_DELETE_CONFIG_SUCCESS: 'SM_SOFT_DELETE_CONFIG_SUCCESS',
  SOFT_DELETE_CONFIG_FAILURE: 'SM_SOFT_DELETE_CONFIG_FAILURE',

  LOAD_RESULTS_REQUEST: 'SM_LOAD_RESULTS_REQUEST',
  LOAD_RESULTS_SUCCESS: 'SM_LOAD_RESULTS_SUCCESS',
  LOAD_RESULTS_FAILURE: 'SM_LOAD_RESULTS_FAILURE',

  LOAD_CHANGES_REQUEST: 'SM_LOAD_CHANGES_REQUEST',
  LOAD_CHANGES_SUCCESS: 'SM_LOAD_CHANGES_SUCCESS',
  LOAD_CHANGES_FAILURE: 'SM_LOAD_CHANGES_FAILURE',

  RUN_NOW_REQUEST: 'SM_RUN_NOW_REQUEST',
  RUN_NOW_SUCCESS: 'SM_RUN_NOW_SUCCESS',
  RUN_NOW_FAILURE: 'SM_RUN_NOW_FAILURE',

  LOAD_DASHBOARD_REQUEST: 'SM_LOAD_DASHBOARD_REQUEST',
  LOAD_DASHBOARD_SUCCESS: 'SM_LOAD_DASHBOARD_SUCCESS',
  LOAD_DASHBOARD_FAILURE: 'SM_LOAD_DASHBOARD_FAILURE',

  LOAD_INSTANCES_REQUEST: 'SM_LOAD_INSTANCES_REQUEST',
  LOAD_INSTANCES_SUCCESS: 'SM_LOAD_INSTANCES_SUCCESS',
  LOAD_INSTANCES_FAILURE: 'SM_LOAD_INSTANCES_FAILURE',

  LOAD_SCHEMAS_REQUEST: 'SM_LOAD_SCHEMAS_REQUEST',
  LOAD_SCHEMAS_SUCCESS: 'SM_LOAD_SCHEMAS_SUCCESS',
  LOAD_SCHEMAS_FAILURE: 'SM_LOAD_SCHEMAS_FAILURE',

  CLEAR_RESULTS: 'SM_CLEAR_RESULTS',

  // Group action types
  LOAD_GROUPS_REQUEST: 'SM_LOAD_GROUPS_REQUEST',
  LOAD_GROUPS_SUCCESS: 'SM_LOAD_GROUPS_SUCCESS',
  LOAD_GROUPS_FAILURE: 'SM_LOAD_GROUPS_FAILURE',

  CREATE_GROUP_REQUEST: 'SM_CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS: 'SM_CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE: 'SM_CREATE_GROUP_FAILURE',

  UPDATE_GROUP_REQUEST: 'SM_UPDATE_GROUP_REQUEST',
  UPDATE_GROUP_SUCCESS: 'SM_UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE: 'SM_UPDATE_GROUP_FAILURE',

  DELETE_GROUP_REQUEST: 'SM_DELETE_GROUP_REQUEST',
  DELETE_GROUP_SUCCESS: 'SM_DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE: 'SM_DELETE_GROUP_FAILURE',

  LOAD_GROUP_CONFIGS_REQUEST: 'SM_LOAD_GROUP_CONFIGS_REQUEST',
  LOAD_GROUP_CONFIGS_SUCCESS: 'SM_LOAD_GROUP_CONFIGS_SUCCESS',
  LOAD_GROUP_CONFIGS_FAILURE: 'SM_LOAD_GROUP_CONFIGS_FAILURE',

  ASSIGN_CONFIGS_TO_GROUP_REQUEST: 'SM_ASSIGN_CONFIGS_TO_GROUP_REQUEST',
  ASSIGN_CONFIGS_TO_GROUP_SUCCESS: 'SM_ASSIGN_CONFIGS_TO_GROUP_SUCCESS',
  ASSIGN_CONFIGS_TO_GROUP_FAILURE: 'SM_ASSIGN_CONFIGS_TO_GROUP_FAILURE',

  REMOVE_CONFIG_FROM_GROUP_REQUEST: 'SM_REMOVE_CONFIG_FROM_GROUP_REQUEST',
  REMOVE_CONFIG_FROM_GROUP_SUCCESS: 'SM_REMOVE_CONFIG_FROM_GROUP_SUCCESS',
  REMOVE_CONFIG_FROM_GROUP_FAILURE: 'SM_REMOVE_CONFIG_FROM_GROUP_FAILURE',

  ACTIVATE_GROUP_REQUEST: 'SM_ACTIVATE_GROUP_REQUEST',
  ACTIVATE_GROUP_SUCCESS: 'SM_ACTIVATE_GROUP_SUCCESS',
  ACTIVATE_GROUP_FAILURE: 'SM_ACTIVATE_GROUP_FAILURE',

  DEACTIVATE_GROUP_REQUEST: 'SM_DEACTIVATE_GROUP_REQUEST',
  DEACTIVATE_GROUP_SUCCESS: 'SM_DEACTIVATE_GROUP_SUCCESS',
  DEACTIVATE_GROUP_FAILURE: 'SM_DEACTIVATE_GROUP_FAILURE',

  DOWNLOAD_GROUP_REPORT_REQUEST: 'SM_DOWNLOAD_GROUP_REPORT_REQUEST',
  DOWNLOAD_GROUP_REPORT_SUCCESS: 'SM_DOWNLOAD_GROUP_REPORT_SUCCESS',
  DOWNLOAD_GROUP_REPORT_FAILURE: 'SM_DOWNLOAD_GROUP_REPORT_FAILURE',

  // Workflow actions for schema monitor changes
  SM_WORKFLOW_ACTION_REQUEST: 'SM_WORKFLOW_ACTION_REQUEST',
  SM_WORKFLOW_ACTION_SUCCESS: 'SM_WORKFLOW_ACTION_SUCCESS',
  SM_WORKFLOW_ACTION_FAILURE: 'SM_WORKFLOW_ACTION_FAILURE',

  SM_WORKFLOW_ROLLBACK_REQUEST: 'SM_WORKFLOW_ROLLBACK_REQUEST',
  SM_WORKFLOW_ROLLBACK_SUCCESS: 'SM_WORKFLOW_ROLLBACK_SUCCESS',
  SM_WORKFLOW_ROLLBACK_FAILURE: 'SM_WORKFLOW_ROLLBACK_FAILURE',
};

const auth = new Auth();
const { getAccessToken } = auth;

const headers = () => ({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'x-access-token': getAccessToken(),
});

// Store one cancel token source per action key; cancel any previous in-flight request
const cancelSources = {};

function cancelPrevious(key) {
  if (cancelSources[key]) {
    cancelSources[key].cancel();
  }
  const source = axios.CancelToken.source();
  cancelSources[key] = source;
  return source;
}

export function loadConfigs() {
  return function(dispatch) {
    const source = cancelPrevious('loadConfigs');
    dispatch({ type: schemaMonitorActions.LOAD_CONFIGS_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/configs', { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_CONFIGS_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_CONFIGS_FAILURE, payload: error, error: true });
      });
  };
}

export function createConfig(data) {
  return function(dispatch) {
    const source = cancelPrevious('createConfig');
    dispatch({ type: schemaMonitorActions.CREATE_CONFIG_REQUEST });
    return axios.post(process.env.REACT_APP_API_URL + '/schemaMonitor/config', data, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.CREATE_CONFIG_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.CREATE_CONFIG_FAILURE, payload: error, error: true });
      });
  };
}

export function updateConfig(configId, data) {
  return function(dispatch) {
    const source = cancelPrevious('updateConfig');
    dispatch({ type: schemaMonitorActions.UPDATE_CONFIG_REQUEST });
    return axios.put(process.env.REACT_APP_API_URL + '/schemaMonitor/config/' + configId, data, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.UPDATE_CONFIG_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.UPDATE_CONFIG_FAILURE, payload: error, error: true });
      });
  };
}

export function deleteConfig(configId) {
  return function(dispatch) {
    const source = cancelPrevious('deleteConfig');
    dispatch({ type: schemaMonitorActions.DELETE_CONFIG_REQUEST });
    return axios.delete(process.env.REACT_APP_API_URL + '/schemaMonitor/config/' + configId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.DELETE_CONFIG_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.DELETE_CONFIG_FAILURE, payload: error, error: true });
      });
  };
}

export function disableConfig(configId) {
  return function(dispatch) {
    const source = cancelPrevious('disableConfig');
    dispatch({ type: schemaMonitorActions.DISABLE_CONFIG_REQUEST });
    return axios.delete(process.env.REACT_APP_API_URL + '/schemaMonitor/config/' + configId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.DISABLE_CONFIG_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.DISABLE_CONFIG_FAILURE, payload: error, error: true });
      });
  };
}

export function softDeleteConfig(configId) {
  return function(dispatch) {
    const source = cancelPrevious('softDeleteConfig');
    dispatch({ type: schemaMonitorActions.SOFT_DELETE_CONFIG_REQUEST });
    return axios.put(process.env.REACT_APP_API_URL + '/schemaMonitor/config/' + configId + '/softdelete', {}, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.SOFT_DELETE_CONFIG_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.SOFT_DELETE_CONFIG_FAILURE, payload: error, error: true });
      });
  };
}

export function loadResults(configId) {
  return function(dispatch) {
    const source = cancelPrevious('loadResults');
    dispatch({ type: schemaMonitorActions.LOAD_RESULTS_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/results/' + configId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_RESULTS_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_RESULTS_FAILURE, payload: error, error: true });
      });
  };
}

export function loadChanges(resultId) {
  return function(dispatch) {
    const source = cancelPrevious('loadChanges');
    dispatch({ type: schemaMonitorActions.LOAD_CHANGES_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/changes/' + resultId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_CHANGES_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_CHANGES_FAILURE, payload: error, error: true });
      });
  };
}

export function runNow(configId) {
  return function(dispatch) {
    const source = cancelPrevious('runNow');
    dispatch({ type: schemaMonitorActions.RUN_NOW_REQUEST });
    return axios.post(process.env.REACT_APP_API_URL + '/schemaMonitor/run/' + configId, {}, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.RUN_NOW_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.RUN_NOW_FAILURE, payload: error, error: true });
      });
  };
}

export function loadDashboard() {
  return function(dispatch) {
    const source = cancelPrevious('loadDashboard');
    dispatch({ type: schemaMonitorActions.LOAD_DASHBOARD_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/dashboard', { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_DASHBOARD_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_DASHBOARD_FAILURE, payload: error, error: true });
      });
  };
}

export function loadInstances() {
  return function(dispatch) {
    const source = cancelPrevious('loadInstances');
    dispatch({ type: schemaMonitorActions.LOAD_INSTANCES_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/instances', { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_INSTANCES_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_INSTANCES_FAILURE, payload: error, error: true });
      });
  };
}

export function loadSchemas(instanceId) {
  return function(dispatch) {
    const source = cancelPrevious('loadSchemas');
    dispatch({ type: schemaMonitorActions.LOAD_SCHEMAS_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/dataDictionary/schemas/' + instanceId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_SCHEMAS_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_SCHEMAS_FAILURE, payload: error, error: true });
      });
  };
}

export function clearResults() {
  return { type: schemaMonitorActions.CLEAR_RESULTS };
}

// ── Group Actions ─────────────────────────────────────────────────────────────

export function loadGroups() {
  return function(dispatch) {
    const source = cancelPrevious('loadGroups');
    dispatch({ type: schemaMonitorActions.LOAD_GROUPS_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/groups', { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_GROUPS_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_GROUPS_FAILURE, payload: error, error: true });
      });
  };
}

export function createGroup(data) {
  return function(dispatch) {
    const source = cancelPrevious('createGroup');
    dispatch({ type: schemaMonitorActions.CREATE_GROUP_REQUEST });
    return axios.post(process.env.REACT_APP_API_URL + '/schemaMonitor/group', data, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.CREATE_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.CREATE_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function updateGroup(groupId, data) {
  return function(dispatch) {
    const source = cancelPrevious('updateGroup');
    dispatch({ type: schemaMonitorActions.UPDATE_GROUP_REQUEST });
    return axios.put(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId, data, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.UPDATE_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.UPDATE_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function deleteGroup(groupId) {
  return function(dispatch) {
    const source = cancelPrevious('deleteGroup');
    dispatch({ type: schemaMonitorActions.DELETE_GROUP_REQUEST });
    return axios.delete(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.DELETE_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.DELETE_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function loadGroupConfigs(groupId) {
  return function(dispatch) {
    const source = cancelPrevious('loadGroupConfigs');
    dispatch({ type: schemaMonitorActions.LOAD_GROUP_CONFIGS_REQUEST });
    return axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/configs', { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.LOAD_GROUP_CONFIGS_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.LOAD_GROUP_CONFIGS_FAILURE, payload: error, error: true });
      });
  };
}

export function assignConfigsToGroup(groupId, configIds) {
  return function(dispatch) {
    const source = cancelPrevious('assignConfigsToGroup');
    dispatch({ type: schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_REQUEST });
    return axios.post(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/configs', { configIds }, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.ASSIGN_CONFIGS_TO_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function removeConfigFromGroup(groupId, configId) {
  return function(dispatch) {
    const source = cancelPrevious('removeConfigFromGroup');
    dispatch({ type: schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_REQUEST });
    return axios.delete(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/config/' + configId, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.REMOVE_CONFIG_FROM_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function activateGroup(groupId) {
  return function(dispatch) {
    const source = cancelPrevious('activateGroup');
    dispatch({ type: schemaMonitorActions.ACTIVATE_GROUP_REQUEST });
    return axios.put(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/activate', {}, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.ACTIVATE_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.ACTIVATE_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function deactivateGroup(groupId) {
  return function(dispatch) {
    const source = cancelPrevious('deactivateGroup');
    dispatch({ type: schemaMonitorActions.DEACTIVATE_GROUP_REQUEST });
    return axios.put(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/deactivate', {}, { headers: headers(), cancelToken: source.token })
      .then((response) => response.data)
      .then((json) => dispatch({ type: schemaMonitorActions.DEACTIVATE_GROUP_SUCCESS, payload: json }))
      .catch((error) => {
        if (axios.isCancel(error)) return;
        dispatch({ type: schemaMonitorActions.DEACTIVATE_GROUP_FAILURE, payload: error, error: true });
      });
  };
}

export function downloadGroupReport(groupId) {
  return function(dispatch) {
    const source = cancelPrevious('downloadGroupReport');
    dispatch({ type: schemaMonitorActions.DOWNLOAD_GROUP_REPORT_REQUEST });
    axios.get(process.env.REACT_APP_API_URL + '/schemaMonitor/group/' + groupId + '/report/pdf', {
      headers: headers(),
      responseType: 'blob',
      timeout: 60000,
      cancelToken: source.token,
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const disposition = response.headers['content-disposition'];
      const filename = disposition ? disposition.split('filename=')[1].replace(/"/g, '') : 'schema-report.pdf';
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      dispatch({ type: schemaMonitorActions.DOWNLOAD_GROUP_REPORT_SUCCESS });
    })
    .catch((error) => {
      if (axios.isCancel(error)) return;
      dispatch({ type: schemaMonitorActions.DOWNLOAD_GROUP_REPORT_FAILURE, payload: error, error: true });
    });
  };
}

//--------- Apply Workflow Action for Schema Change -----------
export function applySchemaChangeWorkflowAction(changeId, action, comments) {
  return function(dispatch) {
    dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ACTION_REQUEST });
    return axios.post(
      `${process.env.REACT_APP_API_URL}/workflow/schema-change/${changeId}/action`,
      { action, comments },
      { headers: headers() }
    )
      .then((response) => response.data)
      .then((json) => {
        dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ACTION_SUCCESS, payload: json });
        return json;
      })
      .catch((error) => {
        dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ACTION_FAILURE, payload: error, error: true });
        throw error;
      });
  };
}

//--------- Rollback Schema Change Workflow Action -----------
export function rollbackSchemaChangeAction(requestId, reason) {
  return function(dispatch) {
    dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ROLLBACK_REQUEST });
    return axios.post(
      `${process.env.REACT_APP_API_URL}/workflow/changes/${requestId}/rollback`,
      { reason },
      { headers: headers() }
    )
      .then((response) => response.data)
      .then((json) => {
        dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ROLLBACK_SUCCESS, payload: json });
        return json;
      })
      .catch((error) => {
        dispatch({ type: schemaMonitorActions.SM_WORKFLOW_ROLLBACK_FAILURE, payload: error, error: true });
        throw error;
      });
  };
}
